import { createFileRoute, redirect } from '@tanstack/react-router'
import ResourceSchedulePageHeader from '../../Pages/ResourceSchedulePage/ResourceSchedulePageHeader'
import ResourceSchedulePage from '../../Pages/ResourceSchedulePage/ResourceSchedulePage'
import PageBody from '../../Pages/Layout/PageBody'
import PageSidebar from '../../Pages/Layout/PageSidebar'
import ResourceScheduleSidebar from '../../Pages/ResourceSchedulePage/ResourceScheduleSidebar'
import { qf } from '../../Queries/queryFormatter'
import SessionStore from '../../State/SessionStore'
import {
    canViewRoute,
    migratedToV2,
} from '../../State/Permissions/HasPermissions'
import { processTRPCData } from '../../Queries/fetchData'
import LoadingSpinner from '../../Components/LoadingSpinner'
import ErrorComponent from '../../Components/ErrorComponent'
import PermissionDenied from '../../Pages/PermissionDenied'
import { setLayoutDefaults } from '@2/layout/layout-store'
import { getCacheItemById } from '@2/cache'
import { CenterPadPageBody } from '@2/layout/page-body'
import { useSidebarStack } from '@2/layout/sidebar'
import { useEffect } from 'react'
import { trpc } from '../../system/trpc'

export const Route = createFileRoute('/_private/resource-schedule')({
    beforeLoad: ({ params, search }) => {
        if (!canViewRoute(SessionStore.user, 'resourceSchedule', params))
            throw new Error('Permission Denied')
        const report = getCacheItemById(
            'resourceScheduleReports',
            search.report
        )
        setLayoutDefaults({
            pageTitle: report?.name || 'Resource Schedule',
            subMenu: 'organisation',
        })
    },
    errorComponent: ({ error, reset }) => {
        if (error.message === 'Permission Denied') return <PermissionDenied />
        return <ErrorComponent error={error} reset={reset} />
    },
    component: Wrapper,
    pendingComponent: LoadingSpinner,
    loader: async ({ location }) => await loader(location.search),
    loaderDeps: ({ search: { report } }) => ({
        report,
    }),
})

const loader = async ({ report }) => {
    const reportId =
        report || SessionStore.organisation?.defaultResourceScheduleReportId

    const data = await trpc.legacy.getResourceSchedulePageData.query({})
    return processTRPCData(data)
}

function Wrapper() {
    const { addToSidebar } = useSidebarStack()
    useEffect(() => {
        addToSidebar(<ResourceScheduleSidebar />)
    }, [])
    if (migratedToV2()) {
        return (
            <>
                <CenterPadPageBody>
                    <ResourceSchedulePage
                        {...Route.useParams()}
                        {...Route.useSearch()}
                    />
                </CenterPadPageBody>
            </>
        )
    }
    return (
        <>
            <ResourceSchedulePageHeader
                {...Route.useParams()}
                {...Route.useSearch()}
            />
            <PageBody>
                <ResourceSchedulePage
                    {...Route.useParams()}
                    {...Route.useSearch()}
                />
            </PageBody>
            <PageSidebar>
                <ResourceScheduleSidebar
                    {...Route.useParams()}
                    {...Route.useSearch()}
                />
            </PageSidebar>
        </>
    )
}
